import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { GetUsersGroupUser, saveUsersGroupUser } from './index';

// Api's
import { userGroupApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getUsersGroupUserSaga({ payload }: GetUsersGroupUser) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      userGroupApi.getDomain,
      payload.groupFilter
    );
    if (response.data.result) {
      yield put(saveUsersGroupUser(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveUsersGroupUser(null, true, resultError.messagesDataError));
    }
  }
}
